














/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Mixin
 ---------------------------------------- */

import BlockMixin from '@mixin/blocks';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    mixins: [
        BlockMixin
    ],

    view(e, bounding, component) {
        const wrapper = component.$el.querySelector('.parallax-block__wrapper');
        const move = Math.round((bounding.top - window.innerHeight) * 0.5) + 'px';
        wrapper.style.left = move;
    },

    customReveal: true,

    reveal: (el, transition) => {
        transition.parallaxReveal(el);
    },

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ParallaxBlock extends Vue {}

